// Static legal page renderer. Same shell + typography for /terms and /privacy.
import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export default function LegalPage({ title, lastUpdated, sections }) {
  return (
    <div className="bg-paper text-ink min-h-[calc(100vh-4rem)]">
      <div className="max-w-3xl mx-auto px-5 md:px-10 py-10 md:py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-ink/60 hover:text-ink mb-8">
          <ChevronLeft size={14} strokeWidth={2.8} /> Back to inonit
        </Link>

        <span className="text-xs uppercase tracking-[0.3em] text-ink/55">{lastUpdated}</span>
        <h1 className="font-display text-5xl md:text-6xl font-extrabold tracking-tight mt-2 mb-2 leading-[0.95]">
          {title}
        </h1>

        <article data-testid="legal-body" className="mt-10 flex flex-col gap-8 text-[15px] md:text-base leading-relaxed">
          {sections.map((s, i) => (
            <section key={i} className="flex flex-col gap-3">
              {s.heading && (
                <h2 className="font-display text-2xl md:text-3xl font-bold tracking-tight mt-2 leading-tight">
                  {s.heading}
                </h2>
              )}
              {s.body.map((p, j) => {
                if (Array.isArray(p)) {
                  return (
                    <ul key={j} className="list-disc pl-6 text-ink/80 flex flex-col gap-1.5">
                      {p.map((li, k) => <li key={k}>{li}</li>)}
                    </ul>
                  );
                }
                if (typeof p === "string" && p.startsWith("mailto:")) {
                  const addr = p.replace("mailto:", "");
                  return <a key={j} href={`mailto:${addr}`} className="text-ink underline decoration-neon decoration-[3px] underline-offset-2 font-bold">{addr}</a>;
                }
                return <p key={j} className="text-ink/80">{p}</p>;
              })}
            </section>
          ))}
        </article>
      </div>
    </div>
  );
}
